// eslint-disable-next-line no-restricted-imports
import type { MemberResponse } from 'app/gamma/src/types/responses';
// eslint-disable-next-line no-restricted-imports
import type { StandardThunkAction, Dispatch } from 'app/gamma/src/types';
// eslint-disable-next-line no-restricted-imports
import type { Action } from '@trello/redux';
// eslint-disable-next-line no-restricted-imports
import { actionCreator } from '@trello/redux';
import { client } from '@trello/graphql';
import type {
  LoadMemberProfileQuery,
  LoadMemberProfileQueryVariables,
} from './LoadMemberProfileQuery.generated';
import { LoadMemberProfileDocument } from './LoadMemberProfileQuery.generated';
import type {
  LoadMemberNonPublicFieldsQuery,
  LoadMemberNonPublicFieldsQueryVariables,
} from './LoadMemberNonPublicFieldsQuery.generated';
import { LoadMemberNonPublicFieldsDocument } from './LoadMemberNonPublicFieldsQuery.generated';

// Action types
export const LOAD_MEMBER_REQUEST = Symbol('loaders/LOAD_MEMBER_REQUEST');
export const LOAD_MEMBER_SUCCESS = Symbol('loaders/LOAD_MEMBER_SUCCESS');

export type LoadMemberRequestAction = Action<
  typeof LOAD_MEMBER_REQUEST,
  string
>;
export type LoadMemberSuccessAction = Action<
  typeof LOAD_MEMBER_SUCCESS,
  MemberResponse
>;

// Action creators
const loadMemberRequest = actionCreator<LoadMemberRequestAction>(
  LOAD_MEMBER_REQUEST,
);
export const loadMemberSuccess = actionCreator<LoadMemberSuccessAction>(
  LOAD_MEMBER_SUCCESS,
);

export const loadMemberProfile = (
  idMemberOrUsername: string,
): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadMemberRequest(idMemberOrUsername));
    const { data, error } = await client.query<
      LoadMemberProfileQuery,
      LoadMemberProfileQueryVariables
    >({
      query: LoadMemberProfileDocument,
      variables: {
        id: idMemberOrUsername,
      },
      context: {
        operationName: 'LoadMemberProfile',
        document: LoadMemberProfileDocument,
      },
    });
    const member = data.member;
    if (error || !member) {
      return;
    }

    dispatch(loadMemberSuccess(member));
  };
};

export const loadMemberNonPublicFields = (
  idMemberOrUsername: string,
): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadMemberRequest(idMemberOrUsername));
    const { data, error } = await client.query<
      LoadMemberNonPublicFieldsQuery,
      LoadMemberNonPublicFieldsQueryVariables
    >({
      query: LoadMemberNonPublicFieldsDocument,
      variables: {
        id: idMemberOrUsername,
      },
      context: {
        operationName: 'LoadMemberNonPublicFields',
        document: LoadMemberNonPublicFieldsDocument,
      },
    });
    const member = data.member;
    if (error || !member) {
      return;
    }

    dispatch(loadMemberSuccess(member));
  };
};
